import { isArray } from "lodash";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import { IRideDto } from "../dto";
import { isEqualNumberArraysAnyOrder } from "../helpers";
import { rideStationsCollapsedIdsAF } from "../recoil";

export const useRideAllStationsCollapsed = (rideDto?: IRideDto) => {
  const stationsCollapsedIds = useRecoilValue(
    rideStationsCollapsedIdsAF(rideDto?.id || 0),
  );

  return useMemo(() => {
    const stationsIds =
      (isArray(rideDto?.metadata?.stationIds) &&
        rideDto?.metadata?.stationIds) ||
      [];
    return isEqualNumberArraysAnyOrder(
      [...stationsIds],
      [...stationsCollapsedIds],
    );
  }, [rideDto?.metadata?.stationIds, stationsCollapsedIds]);
};
